import type { ReactNode } from "react";
import estilos from "./Herramientas.module.css";

/** Barra sobre una lista: buscador, filtros y acciones (descargar). En celular, uno bajo otro. */
export function Herramientas({ children }: { readonly children: ReactNode }) {
  return <div className={estilos.herramientas}>{children}</div>;
}
